/**
 * How each printed box is typed into, which the descriptors do not record.
 *
 * The Word descriptor knows a box exists and what it is called; it does not
 * know whether the box holds a sentence or a paragraph. That is a UI judgement,
 * so it lives here rather than in the generated schema, where changing it would
 * force an artifact regeneration for a purely visual tweak.
 */

import type { FormSection } from './formSectionSchema';
import { isIcs202RichField } from './ics202RichFields';

/** Boxes the printed form gives a full-width block to. */
const NARRATIVE_SOURCES = new Set([
  'objectives',
  'operationalPeriodCommandEmphasis',
  'situationalAwareness',
  'otherAttachmentsText',
  'safetyMessage',
  'specialInstructions',
  'specialMedicalEmergencyProcedures',
  'workAssignments',
  'communications',
  'operationsPersonnel',
  'assignmentUnit',

  // Pratus planning notes, which no printed box corresponds to.
  'priorities',
  'criticalInformationRequirements',
  'keyDecisionsAndProcedures',
  'limitationsAndConstraints',
]);

export type SectionControl = 'input' | 'textarea' | 'richtext';

export const controlFor = (section: FormSection): SectionControl =>
  isIcs202RichField(section.source)
    ? 'richtext'
    : NARRATIVE_SOURCES.has(section.source)
      ? 'textarea'
      : 'input';

/** Rows a narrative box gets before it scrolls. */
export const textareaRows = (section: FormSection): number =>
  section.source === 'objectives' ? 6 : 4;
